<template>
  <div>
    <vs-popup id="instances-list-popup" :active.sync="isActive" :button-close-hidden="false" title="Lista de Conexões" @close="$emit('isActiveFalse')">
      <div v-if="canSee('instances-add')" class="flex flex-wrap-reverse items-center ml-4">
        <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-betweentext-lg font-medium text-base text-primary border border-solid border-primary" @click="$emit('createInstance', tenantName)">
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
          <span class="ml-2 text-base text-primary">Adicionar Nova Conexão</span>
        </div>
      </div>

      <vs-table ref="table" :data="instances" id="tableInstanceList" noDataText="Sem dados disponíveis">
        <template slot="thead">
          <vs-th sort-key="id">Id</vs-th>
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="phone_number">Telefone</vs-th>
          <vs-th sort-key="activated">Conectada</vs-th>
          <vs-th sort-key="is_official">Cloud</vs-th>
          <vs-th v-if="canSee('instances-update')">Ação</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr v-for="( tr, indextr ) in instances" :key="indextr" :data="tr">
            <vs-td>
              <p class="font-medium truncate">{{ tr.id }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.phone_number }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.activated ? 'Sim' : 'Não' }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.is_official ? 'Sim' : 'Não' }}</p>
            </vs-td>

            <vs-td v-if="canSee('instances-update')">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click="openUpdateInstance(tr)"
              />
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vs-popup>

    <div class="w-full" v-if="!isPopup">
      <vs-table ref="table" :data="instances" id="tableInstanceList" noDataText="Sem dados disponíveis" >
        <template slot="thead">
          <vs-th sort-key="id">Id</vs-th>
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="phone_number">Telefone</vs-th>
          <vs-th sort-key="activated">Conectada</vs-th>
          <vs-th sort-key="is_official">Cloud</vs-th>
          <vs-th sort-key="provisioner">Provisioner</vs-th>
          <vs-th sort-key="reset_finished">Reset foi finalizado</vs-th>
          <vs-th v-if="canSee('instances-update')">Ação</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr v-for="( tr, indextr ) in instances" :key="indextr" :data="tr">
            <vs-td>
              <p class="font-medium truncate">{{ tr.id }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.phone_number }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.activated ? 'Sim' : 'Não' }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.is_official ? 'Sim' : 'Não' }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.provisioner || 'N/A' }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.reset_finished ? 'Sim' : 'Não' }}</p>
            </vs-td>

            <vs-td v-if="canSee('instances-update')">
              <div class="inline-flex">
                <vx-tooltip class="cursor-pointer" delay=".2s" color="gray" position="bottom" text="Editar Conexão">
                  <feather-icon
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click="openUpdateInstance(tr)"
                  />
                </vx-tooltip>

                <vx-tooltip v-if="!tr.is_official" class="cursor-pointer" delay=".2s" color="gray" position="bottom" text="Resetar Conexão">
                  <feather-icon
                      icon="PauseCircleIcon"
                      svgClasses="w-5 h-5 hover:text-warning stroke-current ml-2"
                      @click="restartInstance(tr)"
                  />
                </vx-tooltip>

                <vx-tooltip v-if="!tr.is_official" class="cursor-pointer" delay=".2s" color="gray" position="bottom" text="Sincronizar Mensagens">
                  <feather-icon
                      icon="RefreshCwIcon"
                      svgClasses="w-5 h-5 hover:text-success stroke-current ml-2"
                      @click="openSyncMessagesInstance(tr)"
                  />
                </vx-tooltip>

                <vx-tooltip v-if="tr.is_official" class="cursor-pointer" delay=".2s" color="gray" position="bottom" text="Gerar Novo Token">
                  <feather-icon
                      icon="KeyIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current ml-2"
                      @click="generateNewToken(tr)"
                  />
                </vx-tooltip>

                <vx-tooltip class="cursor-pointer" delay=".2s" color="gray" position="bottom" text="Deletar Conexão">
                  <feather-icon
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current ml-2"
                      @click="confirmDeleteInstance(tr)"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>

    <UpdateInstance
      :instance="targetInstance"
      :isActive="updateInstanceModalIsActive"
      :token="token"
      @isActiveFalse="updateInstanceModalIsActive = false"
      @successfullyUpdated="instanceUpdated()"
    />

    <SyncMessagesInstance
      :instance="targetInstance"
      :isActive="syncMessagesInstanceModalIsActive"
      :tenantName="tenantName"
      @isActiveFalse="syncMessagesInstanceModalIsActive = false"
      @successfullyUpdated="instanceUpdated()"
    />

    <vs-popup title="Confirmar Exclusão" :active.sync="deleteInstanceModalIsActive">
      <p class="mt-0 pt-0 font-medium">Tem certeza que deseja excluir a instância "{{ targetInstance.name }}"?</p>
      <div class="flex justify-end mt-4">
        <vs-button class="mr-2" @click="deleteInstanceModalIsActive = false">Cancelar</vs-button>
        <vs-button color="danger" @click="deleteInstance">Excluir</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import {hasPermissionBackOffice} from './../../utils/index';
import UpdateInstance from './UpdateInstance.vue';
import SyncMessagesInstance from './SyncMessagesInstance.vue';

export default {
  data() {
    return {
      instances: [],
      updateInstanceModalIsActive: false,
      syncMessagesInstanceModalIsActive: false,
      deleteInstanceModalIsActive: false,
      targetInstance: {}
    }
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    isPopup: {
      type: Boolean,
      required: false,
      default: true
    },
    tenantName: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  watch: {
    async isActive() {
      if (this.isActive) {
        await this.loadInstances()
      } else {
        this.instances = [];
      }
    }
  },
  methods: {
    verify() {
      const permissions = localStorage.getItem('permissions');
      const twoFactor = localStorage.getItem('twoFactor')
      if (!permissions && !twoFactor) {
        this.$router.push('/user-settings')
      } else if (!permissions && twoFactor) {
        this.$router.push('/two-factor')
      }
    },
    canSee(word) {
      return hasPermissionBackOffice(`tenant-list-${word}`);
    },
    async loadInstances() {
      await this.$store.dispatch('getAllConnections', {
        tenantName: this.tenantName,
        token: this.token
      }).then((response) => {
        this.instances = response.data;
        this.$emit('instances', this.instances);
      }).catch((error) => {
        console.error(error);
        return this.$vs.notify({
          title: 'Erro',
          text: 'Ocorreu um erro inesperado!',
          color: 'danger'
        });
      });
    },
    openUpdateInstance(data) {
      Object.assign(data, {tenantName: this.tenantName});

      this.targetInstance = data;
      this.updateInstanceModalIsActive = true;

      this.$emit('isActiveFalse');
      this.isActive = false;
    },
    openSyncMessagesInstance(data) {
      Object.assign(data, {tenantName: this.tenantName});

      this.targetInstance = data;
      this.syncMessagesInstanceModalIsActive = true;

      this.$emit('isActiveFalse');
      this.isActive = false;
    },
    instanceUpdated() {
      this.updateInstanceModalIsActive = false;
      this.syncMessagesInstanceModalIsActive = false;
      this.isActive = true;
    },
    confirmDeleteInstance(data) {
      this.targetInstance = data;
      this.deleteInstanceModalIsActive = true;
      this.$emit('isActiveFalse');
      this.isActive = false;
    },
    async deleteInstance() {
      this.$vs.loading();
      try {
        await this.$store.dispatch('deleteInstance', {
          id: this.targetInstance.id,
          tenantName: this.tenantName,
          token: this.token
        });

        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: 'Instância excluída com sucesso!'
        });

        this.deleteInstanceModalIsActive = false;
        await this.loadInstances();
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao excluir a instância!'
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async restartInstance(data) {
      this.$vs.loading();
      try {
        await this.$store.dispatch('restartInstance', {
          id: data.id,
          tenantName: this.tenantName,
          token: this.token
        });

        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: 'Instância reiniciada com sucesso!'
        });

        await this.loadInstances();
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao reiniciar a instância!'
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async generateNewToken(data) {
      this.$vs.loading();
      try {
        await this.$store.dispatch('generateNewToken', {
          id: data.id,
          tenantName: this.tenantName,
          token: this.token
        });

        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: 'Novo token gerado com sucesso!'
        });

        await this.loadInstances();
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao gerar novo token!'
        });
      } finally {
        this.$vs.loading.close();
      }
    }
  },
  emits: [
    'createInstance',
    'isActiveFalse',
    'instances'
  ],
  components: {
    UpdateInstance,
    SyncMessagesInstance
  },
  mounted() {
    this.verify();
  }
}
</script>

<style lang="scss">
#instances-list-popup {
  div.vs-popup {
    .vs-popup--content {
      padding: 15px;
      margin: 0;
    }

    margin: 0;
    border-color: rgba(18, 17, 17, 0.769);
    width: 800px !important;

    #tableInstanceList {
      .vs-con-tbody.vs-table--tbody {
        background-color: transparent !important;
        border: 0 !important;
      }

      table.vs-table.vs-table--tbody-table {
        border-collapse: separate;
        border-spacing: 0 0.5rem;
        padding: 0 1rem;
      }

      .vs-table-text {
        text-align: center;
      }

      tbody {
        tr {
          td {
            padding: 0px;
            border-style: solid;
            border-color: #b6bebd6e;
            height: 4em;
          }

          td.td.vs-table--td {
            text-align: center;
          }

          td:first-of-type {
            border-top-left-radius: 18px !important;
            border-bottom-left-radius: 18px !important;
            border-width: 1px 0px 1px 1px;
          }

          td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4), td:nth-of-type(5) {
            border-width: 1px 0px 1px 0px;
          }

          td:last-of-type {
            border-width: 1px 1px 1px 0px;
            border-top-right-radius: 18px !important;
            border-bottom-right-radius: 18px !important;
            padding-right: 10px;
          }
        }
      }
    }
  }
}
</style>
